import { InputTypes } from 'constants/enums';
import { IFormField } from 'models/app';
import React from 'react';
import Modal from 'components/UI/DialogModal';
import Form from 'components/UI/Form';
import { CircularProgress, Grid, Stack } from '@mui/material';
import MuiButton from 'components/UI/MuiButton';
import { ICity } from 'models/city';
import { ICountry } from 'models/country';
import { useTranslation } from 'react-i18next';



interface Props {
  open: boolean;
  loading: boolean;
  city: ICity;
  countries: ICountry[];
  onClose: () => void;
  onSubmit: () => void;
  onChanges: (name: string, value: any) => void;
}




const EditCity: React.FC<Props> = ({ open, loading, city, countries, onClose, onSubmit, onChanges }) => {
  const { t } = useTranslation();
  let countryOptions = countries.map((country) => {
    return {
      value: country.id,
      label: country.name
    };
  });

  let basicFields: IFormField[] = [
    {
      name: 'countryId',
      label: t('T_enter_country_name'),
      type: InputTypes.SELECT,
      placeholder: t('T_enter_country_name'),
      defaultValue: countryOptions.find((c) => c.value === city.countryId),
      options: countryOptions,
      multiple: false,
      internalLabel: true,
      required: true
    },
    {
      name: 'name',
      label: t('T_enter_name'),
      type: InputTypes.TEXT,
      defaultValue: city.cityName,
      internalLabel: true,
      required: true
    },  {
      name: 'nameAr',
      label: `${t('T_enter_name')} ${t('T_in_arabic')}` ,
      type: InputTypes.TEXT,
      defaultValue: city.cityNameAr,
      internalLabel: true,
      required: true
    },

  ];



  return (<>

    <Modal
      open={open}
      onClose={onClose}
      title={t('T_edit_city')}
      maxWidth="lg"
      children={<Stack spacing={2} p={2} >
        <Form fields={basicFields} onChange={onChanges} />
      </Stack>}
      actions={
        <Grid container alignItems={'center'} justifyContent={'space-between'} px={1} >
          <MuiButton variant="contained"
            sx={{ bgcolor: 'warning.main', color: 'white' }}
            size='large' onClick={onClose}>
            {t('T_cancel')}
          </MuiButton>
          <MuiButton variant="contained"
            sx={{ bgcolor: 'primary.main', color: 'white' }}
            disabled={loading}
            size='large' onClick={onSubmit}>
            {t('T_add')}
            <CircularProgress
              size={10}
              sx={{ mx: 2, display: loading ? "" : "none" }}
            />
          </MuiButton>

        </Grid>
      }
    />
  </>
  );
};

export default EditCity;
